import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { Modal } from 'react-bootstrap'

import { AnswerChoice } from '../../../../client/components/Flowciraptor/MultipleChoice'

import closeIcon from 'Assets/x-icon-gray.svg'

import base from 'Styles/base.css'
import style from './style.css'

// we're going to use the multiple choice answer style so we can recycle the radio button's look
const previewChoices = []
previewChoices.push({ value: 0, label: 'At the beginning of the activity.', default: true })
previewChoices.push({ value: 1, label: 'After the ebook sections have all been read.' })
previewChoices.push({ value: 2, label: 'After the quiz has been completed.' })
previewChoices.push({ value: 3, label: 'After the quiz has been retaken.' })

export default class PreviewModalForLcrp extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentlySelectedChoice: 0
    }
  }

  choiceClick (event) {
    this.setState({ currentlySelectedChoice: event.target.value })
  }

  selectionUpdate (currentlySelectedChoice) {
    this.props.onClick()
    this.props.onSelect(currentlySelectedChoice)
  }

  render () {
    return (
      <Modal show={true} className={style.modalWrapper}>
        <div className={style.containerModal}>
          <Modal.Header className={style.topicsHeader}>
            <button
              data-test-id="closeLcrpPreview"
              aria-label="Close LCRP Preview"
              className={classnames(style.closeThis, style.hideModal)}
              onClick={this.props.onClick}
              tabIndex="0"
            >
              <object
                data={closeIcon} type="image/svg+xml"
                className={base.svgIcon}
                tabIndex="-1"
              />
            </button>
            <Modal.Title className={style.title}>
              Where would you like your preview to begin?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={style.text} tabIndex="0">
            <form>
              {
                _.map(previewChoices, (choice) => {
                  return (
                    <AnswerChoice
                      key={choice.value}
                      value={choice.value}
                      label={choice.label}
                      isCorrect={false}
                      isAnswered={false}
                      isRemoved={false}
                      isComplete={false}
                      nukeBg={true}
                      checked={choice.default}
                      onClick={this.choiceClick.bind(this)}
                    />
                  )
                })
              }
            </form>
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <button
              className={classnames('btn-cdl-main', style.previewButton)}
              onClick={() => this.selectionUpdate(this.state.currentlySelectedChoice)}
            >
              Begin Previewing as a Student
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }
}

PreviewModalForLcrp.propTypes = {
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
}
